/*===== AOS =====*/

AOS.init({
  once: true,
  delay: 200,
  duration: 800,
});

/*===== FIREBASE =====*/

const firebaseConfig = {
  apiKey: "AIzaSyCyzBPzvMbnv1xIZKa4_BXPXOJzzihz5xk",
  authDomain: "hinoga-portfolio.firebaseapp.com",
  databaseURL: "https://hinoga-portfolio.firebaseio.com",
  projectId: "hinoga-portfolio",
  storageBucket: "hinoga-portfolio.appspot.com",
  messagingSenderId: "306660686512",
  appId: "1:306660686512:web:de4cc2b1658aa81581d975",
  measurementId: "G-HBBD2Y2KBM",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

/*===== TYPE.JS =====*/

new Typed('#typed', {
  stringsElement: '#typed-strings',
  loop: true,
  typeSpeed: 30,
  backSpeed: 20,
  backDelay: 1300,
});

/*===== MENU SHOW Y HIDDEN =====*/

const navMenu = document.getElementById("nav-menu"),
  toggleMenu = document.getElementById("nav-toggle"),
  closeMenu = document.getElementById("nav-close");

// SHOW
toggleMenu.addEventListener("click", () => {
  navMenu.classList.toggle("show");
});

// HIDDEN
closeMenu.addEventListener("click", () => {
  navMenu.classList.remove("show");
});

/*===== ACTIVE AND REMOVE MENU =====*/

const navLink = document.querySelectorAll(".nav__link");

const linkAction = () => {
  navMenu.classList.remove("show");
};
navLink.forEach((n) => n.addEventListener("click", linkAction));

/*===== SCROLL SECTIONS ACTIVE LINK =====*/

const sections = document.querySelectorAll("section[id]");

const scrollActive = () => {
  const scrollY = window.pageYOffset;
  sections.forEach((current) => {
    const sectionHeight = current.offsetHeight;
    const sectionTop = current.offsetTop - 50;
    sectionId = current.getAttribute("id");

    if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
      document
        .querySelector(".nav__menu a[href*=" + sectionId + "]")
        .classList.add("active");
    } else {
      document
        .querySelector(".nav__menu a[href*=" + sectionId + "]")
        .classList.remove("active");
    }
  });
};

window.addEventListener("scroll", scrollActive);

/*===== DARK/LIGHT MODE =====*/

const checkbox = document.querySelector("#home__switch[name=theme]");

const generateTransition = () => {
  document.documentElement.classList.add("transition");
  window.setTimeout(() => {
    document.documentElement.classList.remove("transition");
  }, 1000);
};

checkbox.addEventListener("change", function () {
  generateTransition();
  if (this.checked) {
    document.documentElement.setAttribute("data-theme", "dark");
  } else {
    document.documentElement.setAttribute("data-theme", "light");
  }
});
